export interface PaginationQueryParams {
  page: number;
  pageSize: number;
}

export interface SearchablePaginationQueryParams extends PaginationQueryParams {
  search: string;
}

export const MinPageSize = 10;
export const MaxPageSize = 100;

export const defaultPaginationQuery: PaginationQueryParams = {
  page: 1,
  pageSize: MinPageSize,
};

export function parsePaginationQuery(
  params: URLSearchParams,
  defaults: PaginationQueryParams = defaultPaginationQuery
): PaginationQueryParams {
  let page = parseInt(params.get('page') ?? String(defaults.page), 10);
  if (Number.isNaN(page) || page < 1) page = defaults.page;

  let pageSize = parseInt(params.get('pageSize') ?? String(defaults.pageSize), 10);
  if (Number.isNaN(pageSize) || pageSize < MinPageSize) pageSize = defaults.pageSize;
  if (pageSize > MaxPageSize) pageSize = MaxPageSize;

  return { page, pageSize };
}

export function appendPaginationParams(
  params: URLSearchParams,
  pagination: PaginationQueryParams,
  defaults: PaginationQueryParams = defaultPaginationQuery
): void {
  if (pagination.page !== defaults.page) params.set('page', String(pagination.page));
  if (pagination.pageSize !== defaults.pageSize) params.set('pageSize', String(pagination.pageSize));
}

